// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
var AppFiber = function (x) {
    return x;
};
var functorAppFiber = function (dictFunctor) {
    var map = Data_Functor.map(dictFunctor);
    return {
        map: function (f) {
            return function (m) {
                return {
                    kill: m.kill,
                    join: map(f)(m.join)
                };
            };
        }
    };
};
var appFiberMapM = function (f) {
    return function (v) {
        return {
            join: f(v.join),
            kill: f(v.kill)
        };
    };
};
export {
    AppFiber,
    appFiberMapM,
    functorAppFiber
};
//# sourceMappingURL=index.js.map
